import { environmentConfig } from "@src/appV2/environment";

interface CognitoConfig {
  userPoolId: string;
  clientId: string;
}

function getCognitoConfig(): CognitoConfig {
  const environmentName = environmentConfig.REACT_APP_ENVIRONMENT_NAME;

  switch (environmentName) {
    case "staging": {
      return {
        userPoolId: "us-west-2_HV1ibP3I6",
        clientId: "6v67adqpeaf6bsh0v8o26lrdjm",
      };
    }
    case "prod-shadow": {
      return {
        userPoolId: "us-west-2_1tSFVnCSa",
        clientId: "37ibpdk8sp79hmber3e20frcgn",
      };
    }
    case "production": {
      return {
        userPoolId: "us-west-2_in7ey5PCw",
        clientId: "7ciadki7t9r81uc82ag7cfg995",
      };
    }
    default: {
      // Development / Local / prod-recreated
      return {
        userPoolId: "us-west-2_N0koNIUOZ",
        clientId: "1tv8sqhok9v1inht70cj77fcgd",
      };
    }
  }
}

export const cognitoConfig = getCognitoConfig();
